import { Modal } from 'antd';

import { CloseIconsForModalWithDataTestId } from '@app/components';
import { NConfirmDeletingElement } from '@app/components/ConfirmDeletingElement/ConfirmDeletingElement.types';
import { generateSpanWithDataTestId } from '@app/shared/utils';

export const ConfirmDeletingElement: NConfirmDeletingElement.Main = ({
  modalOpen,
  setModalOpen,
  handleDelete,
  content,
  title,
  isStageDeletionLoading,
  modalDataTestId = '',
  titleDataTestId = '',
  descriptionDataTestId = '',
  okText = 'Удалить',
  modalType = NConfirmDeletingElement.ModalType.Delete,
}) => {
  return (
    <Modal
      data-testid={modalDataTestId}
      title={generateSpanWithDataTestId(title, titleDataTestId)}
      open={modalOpen}
      okText={okText}
      cancelText="Отменить"
      onCancel={() => setModalOpen(false)}
      onOk={handleDelete}
      okButtonProps={{
        type: 'primary',
        danger: modalType === NConfirmDeletingElement.ModalType.Delete,
        loading: isStageDeletionLoading,
        'data-testid': 'delete',
      }}
      cancelButtonProps={{
        'data-testid': 'cancel',
      }}
      zIndex={2000}
      closeIcon={<CloseIconsForModalWithDataTestId />}
    >
      {generateSpanWithDataTestId(content, descriptionDataTestId)}
    </Modal>
  );
};
